export const urlServer = process.env.REACT_APP_URL_SERVER;
export const apiId = process.env.REACT_APP_API_ID;
export const jsKey = process.env.REACT_APP_JS_KEY;
export const apiServer = process.env.REACT_APP_API_SERVER;
export const apiKey = process.env.REACT_APP_API_KEY;
export const stripeKey = process.env.REACT_APP_STRIPE_KEY;